import type {
  CreateRegionCommand,
  PaginatedListOfRegionDto,
  RegionDetailDto,
  RegionDto,
  UpdateRegionCommand
} from "../models/models"
import type { HttpResponse } from "../redux/http/http.types"
import type { Region } from "../redux/regions/region.types"
import { dispatchSnackbar } from "../services/SnackbarService"
import { hasFailed } from "../utils"
import { get, post, put, remove } from "./HttpService"

export async function postRegion(region: Region): Promise<string> {
  const command: CreateRegionCommand = {
    chapterId: region.chapterId,
    name: region.name,
    licenceIds: region.licenceIds,
    order: region.order
  }

  const response: HttpResponse<string> = await post<string, CreateRegionCommand>("region", "regions", command)

  dispatchSnackbar("regio", "POST", !hasFailed(response, true))

  return response.data!
}

export async function getRegionsByChapterAndLicenceIds(chapterId: string, licenceIds: string[]): Promise<RegionDto[]> {
  const queryString: string = licenceIds.join("&licenceIds=")

  const response: HttpResponse<RegionDto[]> = await get<RegionDto[]>(
    "region",
    `regions/getByLicenceIds?chapterId=${chapterId}&licenceIds=${queryString}`
  )

  return response.data!
}

export async function getAllRegions(queryString: string): Promise<PaginatedListOfRegionDto> {
  const response: HttpResponse<PaginatedListOfRegionDto> = await get<PaginatedListOfRegionDto>(
    "region",
    `regions${queryString}`
  )

  return response.data!
}

export async function getAllRegionsByChapterId(chapterId: string): Promise<RegionDto[]> {
  const response: HttpResponse<RegionDto[]> = await get<RegionDto[]>("region", `chapters/${chapterId}/regions`)

  return response.data!
}

export async function getRegion(id: string): Promise<RegionDetailDto> {
  const response: HttpResponse<RegionDetailDto> = await get<RegionDetailDto>("region", `regions/${id}`)

  return response.data!
}

export async function putRegion(region: Region): Promise<void> {
  const command: UpdateRegionCommand = {
    id: region.id as string,
    chapterId: region.chapterId,
    name: region.name,
    licenceIds: region.licenceIds,
    order: region.order
  }

  const response: HttpResponse = await put<UpdateRegionCommand>("region", "regions", command)

  dispatchSnackbar("regio", "PUT", !hasFailed(response))
}

export async function removeRegion(id: string): Promise<void> {
  const response: HttpResponse = await remove("region", `regions/${id}`)

  dispatchSnackbar("regio", "DELETE", !hasFailed(response))
}
